export default {
  methods: {
    dateFormat (date, options) {
      if (!options) {
        return new Date(date).toLocaleDateString(this.$i18n.locale)
      }
    }
  }
}
